import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/evolucao' };
/////////////////////////////////////////////////////////////////////////////////

export function createEvolucaoAnimal(payload) {
  return httpService.post(args, payload);
}

export function updateEvolucaoAnimal(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listEvolucaoAnimal(param) {
  return httpService.get({ ...args, args: param });
}

export function findEvolucaoAnimal(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllEvolucaoAnimal() {
  return httpService.get({ ...args, path: '/pecuaria/evolucao/all' });
}

export function deleteEvolucaoAnimal(id) {
  return httpService.del({ ...args, args: `/${id}` });
}